import microApp from '@micro-zoe/micro-app';
/** 初始化微应用 */
export function microAppInit() {
  if (!microApp || microApp.hasInit) {
    console.log('microApp 已存在');
    return;
  }
  const ts = new Date().getTime();
  localStorage.setItem('microAppTs', ts.toString());
  microApp.start({
    tagName: 'micro-app-style-editor',
    // 'disable-memory-router': true,
    'disable-patch-request': true,
    'router-mode': 'native-scope',
  });
}
/** 打开微应用 */
export function microAppOpen(name, data) {
  console.log('microAppOpen', name, data);
  const ts = new Date().getTime();
  microApp.setData(name, {
    appConfig: { ...data, ts },
    creator: data?.creatorInfo,
  });
}
/**
 * 发送消息到微应用
 * @param name 微应用名称
 * @param data 要发送的数据
 */
export function sendMessageToMicroApp(name, data) {
  if (!microApp) {
    return;
  }
  microApp.setData(name, { message: data });
}
/**
 * 卸载微应用
 * @param name 微应用名称
 * @param callBack 卸载完成回调
 */
export function microAppUnmount(name, callBack) {
  if (!microApp) {
    return;
  }
  // 先清空数据，再卸载应用
  microApp.setData(name, { appConfig: {} });
  microApp.clearData(name);
  microApp
    .unmountApp(name, { destroy: true, clearAliveState: true, clearData: true })
    .then(() => callBack?.());
}
